import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {StepMenuLimit} from './step-menu.model';

@Component({
    selector: 'app-step-limit',
    standalone: true,
    imports: [TranslatePipe],
    template: `
        <p class="d-flex align-items-start gap-2 fw-bold text-danger mb-1">
            <i class="bi bi-exclamation-circle flex-shrink-0" aria-hidden="true"></i>
            <span>
                {{
                    limit().headline.key | translate: 'online' : 'export' : limit().headline.params
                }}
            </span>
        </p>
        @for (detail of limit().details; track detail.key) {
            <p class="limit-detail mb-1">
                {{ detail.key | translate: 'online' : 'export' : detail.params }}
            </p>
        }
        @if (limit().adviceKeys.length > 0) {
            <p class="limit-advice mb-0">
                <strong>
                    {{
                        'customizedexports_export_limits_advice_title'
                            | translate: 'online' : 'export'
                    }}
                </strong>
                @for (adviceKey of limit().adviceKeys; track adviceKey) {
                    <span class="ms-1">{{ adviceKey | translate: 'online' : 'export' }}</span>
                }
            </p>
        }
    `,
    styles: `
        :host {
            display: block;
            font-size: 0.875rem;
        }

        .limit-detail {
            color: var(--bs-secondary-color);
        }

        .limit-advice {
            margin-top: 0.625rem;
            padding-top: 0.625rem;
            border-top: 1px solid rgba(var(--bs-danger-rgb), 0.2);
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepLimitComponent {
    readonly limit = input.required<StepMenuLimit>();
}
